module.exports = __webpack_public_path__ + "static/media/undraw_server_cluster_jwwq.b2c96870.png";